export enum CollectionFilterTypes {
  Boolean = 'Boolean',
  Date = 'Date',
  Dictionary = 'Dictionary',
}
